<script setup lang="ts">
import { useModal } from 'vue-final-modal'
import ModalConfirm from './ModalConfirm.vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import whatNowEntries from '@/resources/what-now.json'

const { t } = useI18n();

const props = defineProps<{
  contextId: number;
}>();

const contents = computed(() => {
  const parts = t('what-now.' + props.contextId).split('-');
  const lang = parts[0];
  const entry = Number(parts[1]);
  console.log('parts: ', parts, lang, entry);
  switch(lang) {
    case 'no' || 'en' : {
      return whatNowEntries[lang][entry].body;
    }
    default : {
      return 'Unknown value for language: [' + lang + ']';
    }
  }
});

const title = computed(() => {
  const parts = t('what-now.' + props.contextId).split('-');
  const lang = parts[0];
  const entry = Number(parts[1]);
  switch(lang) {
    case 'no' || 'en' : {
      return whatNowEntries[lang][entry].title;
    }
    default : {
      return 'Unknown value for language: [' + lang + ']';
    }
  }
})

const instance = useModal({
  component: ModalConfirm,
  attrs: {
    title: title,
    onConfirm() {
      instance.close();
    }
  },
  slots: {
    default: contents
  },
})

</script>
<template>
  <span class="pulse">
    <button @click="() => instance.open()">{{ $t('common.what-now') }}</button>
  </span>
</template>

<style scoped>
button {
  border-radius: 8px 8px 0 0;
  padding-bottom: 0px;
  min-height: 28px;
}

.pulse {

  width: 100%;
  border: none;
  border-radius: 8px;
  padding-bottom: 0px;
  height: 36px;
  background: linear-gradient(to right, red,yellow,green);
}

.pulse:hover {
  background: none;
  animation: rainbow 3s linear 0s infinite;
}

@keyframes rainbow {
  0%,
  to {
    background-color: red;
  }
  33% {
    background-color: yellow;
  }
  66% {
    background-color: green;
  }
  100% {
    background-color: red;
  }
}

</style>
